import { POPUP_A11Y_REGISTER_KEY } from '@/constants/popupA11y.js';

export default {
  inject: {
    registerPopupA11y: {
      from: POPUP_A11Y_REGISTER_KEY,
      default: null,
    },
  },
  methods: {
    registerPopupA11yMeta(meta) {
      if (typeof this.registerPopupA11y === 'function') {
        this.registerPopupA11y(meta || { titleId: null, describedBy: null });
      }
    },
    clearPopupA11yMeta() {
      this.registerPopupA11yMeta({ titleId: null, describedBy: null });
    },
  },
  beforeUnmount() {
    this.clearPopupA11yMeta();
  },
};
